import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { useHistory } from "react-router-dom";
import ValidateService from "../../../components/ValidateService/ValidateService";

//PAGE
// List Table 5
import P420List from "./P420List";

// Dialog
import P420Dialog from "./P420Dialog";

//CSS
import "../../../components/DataTable/DataTable.css";

//SERVICE
import { pCtGisProgressColorList } from "../../../service/400/P420Service";
import { Button } from "primereact/button";

export default function P412() {
    const history = useHistory();
    const toast = useRef(null);

    const [loading, setLoading] = useState(false);

    //SEARCH
    const [dataSearch] = useState({ userId: dataUserSession() ? dataUserSession().userId : "" }); //,setDataSearch

    // DATA
    const [errData, setErrData] = useState(null);
    // const [dataForm, setDataForm] = useState(null);
    const [dataTable, setDataTable] = useState([]);

    // DIALOG
    const [dialog, setDialog] = useState({
        open: false,
        action: "",
        dataSet: null,
    });

    useEffect(() => {
        if (!dataUserSession()) {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        onGetCtGisProgressColorList();
    }, [dataSearch, dialog]);

    const onGetCtGisProgressColorList = () => {
        setLoading(true);
        pCtGisProgressColorList(dataSearch).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };
    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const handlerOpenDialog = (_open, act, data) => {
        setDialog({ open: _open, action: act, dataSet: data, userId: dataSearch.userId });
    };

    const handlerAction = (rowData) => {
        handlerOpenDialog(true, rowData.action, rowData);
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        {/* <h2 className="p-m-0">เฉดสีแสดงความก้าวหน้าของงานบนGIS</h2>
                        <hr /> */}
                        <div className="p-grid  p-fluid">
                            <div className="p-field p-col-12 p-md-6">
                                <Button
                                    className="p-button-secondary p-button btn-long-top-responsive"
                                    icon="pi pi-arrow-left"
                                    label="กลับหน้าจอหลัก"
                                    // style={{ display: 'flex',marginBottom : '10px' }}
                                    style={{ width: 170, marginLeft: "5px" }}
                                    onClick={() => {
                                        history.push("/400");
                                    }}
                                />
                            </div>
                        </div>
                        <P420List dataTable={dataTable} setAction={handlerAction} />
                    </div>
                </div>
            </div>

            {dialog.open === true ? (
                <>
                    <P420Dialog dialog={dialog} setDialog={setDialog} />
                </>
            ) : (
                ""
            )}
        </>
    );
}
